<template>
  <div>
    <div class="header-tra-cuu">
      <span class="ml-3">Tàu thuyền trong cảng </span>
    </div>
    <div style="display: flex;">
      <v-text-field
        clearable
        class="pt-1"
        style="width: 170px; flex: none;"
        v-model="nameOfShip"
        placeholder="Nhập tên tàu"
        @keyup.enter="loadDataTau()"
      ></v-text-field>
      <v-btn flat small class="ml-0 mr-2 py-0 my-0" @click="loadDataTau()" style="text-transform: none; color: #1d52e8;"> <v-icon size="17">search</v-icon> Tìm kiếm</v-btn>
    </div>

    <content-placeholders v-if="loadingDataItem">
      <content-placeholders-img />
      <content-placeholders-heading />
    </content-placeholders>
    
    <div v-for="(value, name) in dataItems">
      <div class="caption-header mt-3">
        {{value[0]['portRegionName'] || ''}}
      </div>
      
      <div class="mt-3" style="overflow: auto;">
        <v-data-table
          :headers="headersKhDieuDong"
          :items="value"
          class="table-bordered danhSachHoSoTable__class"
          hide-actions
          :no-data-text="'Không tìm thấy hồ sơ '"
          :no-results-text="'Không tìm thấy hồ sơ '"
        >
          <template slot="headers" slot-scope="props">
            <tr style="background: #316BB6; color: #ffff;">
              <th>
                <v-checkbox v-model="selectAll" @change="changeSelectAll(value)"></v-checkbox>
              </th>
              <th style="color: #ffff !important; font-weight: normal !important;" v-for="header in props.headers" v-if="header['id'] !== 'checkbox'" v-html="header.text">
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <td>
              <v-checkbox v-model="selectItems" :value="props.item"></v-checkbox>
            </td>
            <td class="text-xs-center" v-for="(itemKey, index) in headersKhDieuDong" v-if="itemKey['id'] !== 'checkbox'">
              <span v-if="itemKey.id === 'chanelCodeList'">
                <div v-for="(item, index) in props.item[itemKey.display]" :key="'chanelCodeList' + index">{{item}}</div>
              </span>
              <span v-else-if="itemKey.id === 'portHarbourCode'">
                <span>{{props.item['portHarbourName']}}, {{props.item['portWharfName']}}</span>
              </span>
              <span v-else>{{props.item[itemKey.display]}}</span>
            </td>
          </template>
        </v-data-table>
      </div>
    </div>
    
    <div v-for="item in arrNotData" class="caption-header mt-3">
      {{item}}
    </div>

  </div>
</template>
<script>
import supportData from '@/store/support.json'
import VueScrollingTable from 'vue-scrolling-table'
import toastr from 'toastr'
toastr.options = {
  'closeButton': true,
  'timeOut': '3000'
}
const groupBy = key => array =>
array.reduce((objectsByKeyValue, obj) => {
  const value = obj[key]
  objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj)
  return objectsByKeyValue
}, {})
export default {
  props: {
    type: '',
    documentTypeCode: '',
    documentStatusCode: '',
    stateDisplay: ''
  },
  components: {
    'vue-scrolling-table': VueScrollingTable
  },
  provide: {
  },
  data: () => ({
    nameOfShip: '',
    dialogTauXC: false,
    typeNavigate: '',
    loadingDialog: false,
    dialogPTTND: false,
    titleDS: '',
    adv: {
    },
    selectAll: false,
    selectItems: [],
    itemsDialog: [],
    itemsDialogXC: [],
    arrNotData: [],
    supportData: supportData,
    searchTopTauAll: '',
    dataItems: {
    },
    menuTopTauAll: false,
    dateSearchTopTauAll: '',
    headersKhDieuDong: supportData.headersTauTrongCang,
    loadingDataItem: false,
    portRegionItems: [],
    itineraryNo: '',
    maritimeCode: 0
  }),
  watch: {
    '$route': function (newRoute, oldRoute) {
      let vm = this
      if (vm.code === 'KeHoachDieuDongTau2') {
        vm.$store.commit('setSwitch1', true)
      } else {
        vm.$store.commit('setSwitch1', false)
      }
    },
    dateSearchTopTauAll (val) {
      this.searchTopTauAll = this.parseDate(val)
      this.loadDataTau()
    },
    selectItems (val) {
      let vm = this
      if (val.length) {
        vm.selectAll = true
      } else {
        vm.selectAll = false
      }
    }
  },
  computed: {
    loadingInitData () {
      return this.$store.getters.loadingInitData
    },
    switch1 () {
      return this.$store.getters.switch1
    }
  },
  created () {
    let vm = this
    vm.$store.dispatch('loadInitResource').then(function (result) {
      vm.loadMaritimeCode().then(result => {
        if (vm.code === 'KeHoachDieuDongTau2') {
          vm.$store.commit('setSwitch1', true)
        } else {
          vm.$store.commit('setSwitch1', false)
        }
        // vm.loadDsTau()
        vm.getCurentDate()
        vm.addColumnTable()
        vm.$store.commit('setPttnd', false)
      })
    })
  },
  methods: {
    loadMaritimeCode: function (query) {
      var vm = this
      let param = {
      }
      param['isDelete'] = 0
      param['start'] = -1
      param['end'] = -1
      return new Promise((resolve, reject) => {
        vm.$store.dispatch('getDmGtReportCategories', param).then(function (result) {
          if (result && result['length']) {
            vm.maritimeCode = result[0] ? result[0]['category'] : 0
            resolve(result[0])
          } else {
            resolve({})
          }
        }).catch(function (xhr) {
          console.log(xhr)
          reject(false)
        })
      })
    },
    loadPortRegion: function (query, data) {
      var vm = this
      let param = {
        categoryId: 'DM_PORT_REGION'
      }
      if (vm.id && vm.id !== '0') {
        delete param['isDelete']
      } else {
        param['isDelete'] = 0
      }
      if (query) {
        for (var key in query) {
          param[key] = query[key]
        }
      }
      param['maritimeCode'] = vm.maritimeCode
      param['start'] = -1
      param['end'] = -1
      vm.$store.dispatch('loadDataDm', param).then(function (result) {
        vm.portRegionItems = result
        let arrNotData = []
        if (data) {
          vm.portRegionItems.forEach((item, index) => {
            if (!data.hasOwnProperty(item['portRegionCode'])) {
              console.log('not Property', item['portRegionCode'])
              arrNotData.push(item['portRegionNameVN'])
            }
          })
        }
        vm.arrNotData = arrNotData
      }).catch(function (xhr) {
        console.log(xhr)
      })
    },
    changeTypePart () {
      let vm = this
      if (vm.switch1) {
        vm.$router.push({
          path: '/tra-cuu/ke_hoach/0/0/KeHoachDieuDongTau2'
        })
      } else {
        vm.$router.push({
          path: '/tra-cuu/ke_hoach/0/0/KeHoachDieuDongTau'
        })
      }
    },
    getCurentDate () {
      let date = new Date()
      this.dateSearchTopTauAll = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
    },
    parseDate (date) {
      if (!date) return null
      console.log(date)
      const [year, month, day] = date.split('-')
      return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`
    },
    loadDataTau () {
      let vm = this
      vm.loadingDataItem = true
      vm.$store.dispatch('loadInitResource').then(function (resultInit) {
        return new Promise((resolve, reject) => {
          let url = resultInit['getVmaScheduleAnchorage_Port_URL']
          vm.$store.dispatch('loadDanhSachTauBien', {
            url: url,
            start: -1,
            end: -1,
            shipPosition: 2,
            flag: true,
            nameOfShip: vm.nameOfShip
            // portofAuthority: vm.maritimeCode,
            // portOfAuthority: vm.maritimeCode,
            // maritimeCode: vm.maritimeCode,
          }).then(result => {
            if (result && !result.hasOwnProperty('errorCode')) {
              console.log('Source=====dataItem==============>>>>>>>>', result)
              let data = result['data'] || []
              let groupByPortRegionName = groupBy('portRegionCode')
              vm.dataItems = groupByPortRegionName(data)
              console.log('data+++dataItems===================>>>>>>>>', vm.dataItems)
              vm.loadingDataItem = false
              vm.loadPortRegion(null, vm.dataItems)
              resolve(vm.dataItems)
            } else {
              vm.loadingDataItem = false
              resolve([])
            }
          }).catch(xhr => {
            vm.loadingDataItem = false
            resolve([])
          })
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// TauTrongCang.vue?4390bb72